import WithRender from "../../templates/layouts/layoutAdminDefaultSelection.html";

export default WithRender({
  computed: {}
});
